export enum BackupServices {
    Databases = 'databases',
    Tablesdb = 'tablesdb',
    Documentsdb = 'documentsdb',
    Vectorsdb = 'vectorsdb',
    Functions = 'functions',
    Storage = 'storage',
}